import { lazy } from 'react';

import { getRoutesArray } from './manager';

const HomePage = lazy(() => import('~/domains/home/HomePage'));
const ProductsListPage = lazy(() => import('~/domains/products'));
const ProductViewPage = lazy(() => import('~/domains/products/ProductViewPage'));
const ProductsCreateUpdatePage = lazy(() => import('~/domains/products/ProductsCreateUpdatePage'));
const SubscriptionsListPage = lazy(() => import('~/domains/subscriptions'));
const SubscriptionViewPage = lazy(() => import('~/domains/subscriptions/SubscriptionViewPage'));
const ContractTermsListPage = lazy(() => import('~/domains/contracts'));
const ContractTermsCreateUpdatePage = lazy(() => import('~/domains/contracts/ContractTermsCreateUpdatePage'));
const AssistedPurchaseListPage = lazy(() => import('~/domains/assisted-purchase'));
const AssistedPurchaseViewPage = lazy(() => import('~/domains/assisted-purchase/AssistedPurchaseViewPage'));
const UpdateStatusInstanceDialog = lazy(() => 
    import('~/domains/assisted-purchase/components/UpdateStatusInstanceDialog'));
const AdditionaisListPage = lazy(() => import('~/domains/additionais'));
const AdditionalCreateUpdatePage = lazy(() => import('~/domains/additionais/AdditionaisCreateUpdatePage'));
const IntegrationMappingListPage = lazy(() => import('~/domains/integration-mapping'));
const IntegrationMappingItemCreateUpdatePage = lazy(() => 
    import('~/domains/integration-mapping/components/ItemCreateUpdatePage'));
const IntegrationMappingCalculationCreateUpdatePage = lazy(() =>
    import('~/domains/integration-mapping/components/CalculationCreateUpdatePage'));
const IntegrationMappingContractCreateUpdatePage = lazy(() =>
    import('~/domains/integration-mapping/components/ContractCreateUpdatePage'));
const IntegrationMappingDiscountCreateUpdatePage = lazy(() =>
    import('~/domains/integration-mapping/components/DiscountCreateUpdatePage'));
const IntegrationErrorMonitorListPage = lazy(() => import('~/domains/integration-error-monitor'));

const ROUTES = [
    {
        path: '/',
        menuKey: '/',
        component: HomePage,
        text: 'Home',
        icon: {
            name: 'dashboard',
        },
        exact: true,
    },
    {
        path: '/produtos',
        menuKey: '/produtos',
        component: ProductsListPage,
        text: 'Produtos',
        icon: {
            name: 'shopping-basket',
        },
        exact: true,
    },
    {
        path: '/produtos/novo',
        menuKey: '/produtos',
        component: ProductsCreateUpdatePage,
        exact: true,
    },
    {
        path: '/produtos/:productId',
        menuKey: '/produtos',
        component: ProductsCreateUpdatePage,
        exact: true,
    },
    {
        path: '/produtos/:productId/visualizar',
        menuKey: '/produtos',
        component: ProductViewPage,
        exact: true,
    },
    {
        group: 'autoSale',
        groupName: 'Auto Compra',
        icon: { 
            name: 'credit-card',
        },
        routes: [
            {
                path: '/assinaturas',
                menuKey: '/assinaturas',
                component: SubscriptionsListPage,
                text: 'Assinaturas',
                icon: {
                    name: 'receipt',
                },
                exact: true,
            },
            {
                path: '/assinatura/:subscriptionId/visualizar',
                menuKey: '/assinaturas',
                component: SubscriptionViewPage,
                exact: true,
            },
            {
                path: '/termo-contrato',
                menuKey: '/contract',
                component: ContractTermsListPage,
                text: 'Termos de Contrato',
                icon: {
                    name: 'description',
                },
                exact: true,
            },
            {
                path: '/termo-contrato/novo',
                menuKey: '/contract',
                component: ContractTermsCreateUpdatePage,
                exact: true,
            },
            {
                path: '/termo-contrato/:contractTermId',
                menuKey: '/contract',
                component: ContractTermsCreateUpdatePage,
                exact: true,
            },
            {
                path: '/adicionais',
                menuKey: '/additionais',
                component: AdditionaisListPage,
                text: 'Adicionais',
                icon: {
                    name: 'add',
                },
                exact: true,
            },
            {
                path: '/adicionais/novo',
                menuKey: '/additionais',
                component: AdditionalCreateUpdatePage,
                exact: true,
            },
            {
                path: '/adicionais/:additionalId',
                menuKey: '/additionais',
                component: AdditionalCreateUpdatePage,
                exact: true,
            },
        ],
    },
    {
        group: 'assistedSale',
        groupName: 'Venda Assistida',
        icon: { 
            name: 'business',
        },
        routes: [
            {
                path: '/assisted-purchases',
                menuKey: '/assisted-purchases',
                component: AssistedPurchaseListPage,
                text: 'Contratações',
                icon: { 
                    name: 'description',
                },
                exact: true,
            },
            {
                path: '/assisted-purchase/:assistedPurchaseId/visualizar',
                menuKey: '/assisted-purchases',
                component: AssistedPurchaseViewPage,
                exact: true,
            },
            {
                path: '/assisted-purchase/:assistedPurchaseId/status-change',
                menuKey: '/assisted-purchases',
                component: UpdateStatusInstanceDialog,
                exact: true,
            },
            {
                path: '/integration-mappings',
                menuKey: '/integration-mappings',
                component: IntegrationMappingListPage,
                text: 'Mapeamento de Integração',
                icon: { 
                    name: 'compare-arrows',
                },
                exact: true,
            },
            {
                path: '/integration-mapping/new-item',
                menuKey: '/integration-mappings',
                component: IntegrationMappingItemCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/ITEM/:mappingId/view',
                menuKey: '/integration-mappings',
                component: IntegrationMappingItemCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/new-contract',
                menuKey: '/integration-mappings',
                component: IntegrationMappingContractCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/CONTRACT/:mappingId/view',
                menuKey: '/integration-mappings',
                component: IntegrationMappingContractCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/new-calculation',
                menuKey: '/integration-mappings',
                component: IntegrationMappingCalculationCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/CALCULATION/:mappingId/view',
                menuKey: '/integration-mappings',
                component: IntegrationMappingCalculationCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/new-discount',
                menuKey: '/integration-mappings',
                component: IntegrationMappingDiscountCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-mapping/DISCOUNT/:mappingId/view',
                menuKey: '/integration-mappings',
                component: IntegrationMappingDiscountCreateUpdatePage,
                exact: true,
            },
            {
                path: '/integration-error-monitor',
                menuKey: '/integration-error-monitor',
                component: IntegrationErrorMonitorListPage,
                text: 'Monitor de Erros de Integração',
                icon: { 
                    name: 'warning',
                },
                exact: true,
            },
        ],
    },
];

export default ROUTES;

export const allRoutes = getRoutesArray({
    group: 'root',
    routes: ROUTES,
});
